import { useState } from 'react';
import { useParams } from 'react-router-dom';

import Column from '../../layouts/Column';
import ModalBuildFastTrack from '../FastTracks/components/ModalBuildFastTrack';
import NarrativeFlowView from '../../components/NarrativeFlowView';

const FastTrack = () => {
  const { flow_id: flowId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <NarrativeFlowView
      flowId={flowId}
      onReprompt={() => setIsModalOpen(true)}
      renderAfterContent={({ fastTrackRoute, flow }) =>
        isModalOpen ? (
          <ModalBuildFastTrack
            flowId={flow?.id}
            route={fastTrackRoute}
            setIsModalOpen={setIsModalOpen}
          />
        ) : null
      }
    />
  );
};

const FastTrackLayout = () => (
  <Column>
    <FastTrack />
  </Column>
);

export default FastTrackLayout;
